import { useMutation, useQuery, useQueryClient } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useTaxRates = (config) => {
  return useQuery({
    ...config,
    queryKey: "tax-rates",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/tax-rates`,
        signal,
      }),
  });
};

export const useCreateTaxRateMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/tax-rates`,
        method: "POST",
        body: data,
      }),
    onSuccess: (response) => {
      const previous = client.getQueryData("tax-rates") || [];
      client.setQueryData("tax-rates", [...previous, response.single]);
    },
  });
};

export const useUpdateTaxRateMutation = (id) => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/tax-rates/${id}`,
        method: "PUT",
        body: data,
      }),
    onSuccess: () => {
      client.invalidateQueries("tax-rates");
    },
  });
};

export const useDeleteTaxRateMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (id) =>
      fetch({
        url: `${Angie.api_url}/tax-rates/${id}`,
        method: "DELETE",
      }),
    onMutate: (id) => {
      const previous = client.getQueryData("tax-rates") || [];
      client.setQueryData(
        "tax-rates",
        previous.filter((item) => item.id !== id)
      );
    },
    onSuccess: () => {
      client.invalidateQueries("tax-rates");
    },
  });
};

export const useSetDefaultTaxRateMutation = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (id) =>
      fetch({
        url: `${Angie.api_url}/tax-rates/default`,
        method: "PUT",
        body: {
          tax_rate_id: id,
        },
      }),
    onSuccess: (response) => {
      const previous = client.getQueryData("tax-rates") || [];
      client.setQueryData(
        "tax-rates",
        previous.reduce((prev, next) => {
          if (next.id === response.single.id) {
            prev.push(response.single);
          } else {
            prev.push({ ...next, is_default: false });
          }
          return prev;
        }, [])
      );
    },
  });
};

export const useUnsetDefaultTaxRateMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/tax-rates/default`,
        method: "DELETE",
      }),
    onSuccess: () => {
      client.invalidateQueries("tax-rates");
    },
  });
};
